import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from './Button';
import ModalWithExternalHeader from './ModalWithExternalHeader';
import styles from './WelcomeModal.css';
import mokaLogo from './images/moka-logo-with-tagline.png';
import illustrationImage from './images/ftue-start.png';

function WelcomeModal(props) {
  const { isShowing, onClose } = props;

  return (
    <ModalWithExternalHeader
      show={isShowing}
      externalHeaderText="Selamat Datang"
    >
      <Modal.Body className={styles.body}>
        <div className={styles.imageContainer}>
          <img src={mokaLogo} className={styles.mokaLogo} />
        </div>

        <div className={styles.imageContainer}>
          <img src={illustrationImage} className={styles.illustrationImage} />
        </div>

        <p className={styles.description}>
          <b>Selamat datang di Backoffice Moka!</b> Kami senang Anda berada di
          tempat yang tepat untuk mengelola dan mengintegrasikan semua kebutuhan
          bisnis kapan pun, di mana pun.
        </p>

        <p className={styles.description}>
          Sekarang, kami akan memandu Anda untuk membuktikan semua keunggulan
          fitur Moka.
        </p>

        <div className={styles.footer}>
          <Button type="button" onClick={onClose} variant="primary">
            Mulai Tur Sekarang
          </Button>
        </div>
      </Modal.Body>
    </ModalWithExternalHeader>
  );
}

WelcomeModal.defaultProps = {
  isShowing: false,
  onClose: () => {},
};

WelcomeModal.propTypes = {
  isShowing: PropTypes.bool,
  onClose: PropTypes.func,
};

export default WelcomeModal;
